import styles from "./SearchBox.styles.scss";
import Icon from "../Icon/Icon";

const SearchBox = ({query = '', onChangeQuery}) => {
  const isFilled = query.length > 0;
  return <div className={styles.searchBoxContainer}>
    <input
      type="text"
      placeholder="Pesquisar usuário"
      className={[styles.searchBox, isFilled && styles.searchBoxFilled].join(" ")}
      onChange={onChangeQuery}
      value={query}
    />
    <Icon name="magnify" />
  </div>
};

export default SearchBox;



// WEBPACK FOOTER //
// ./components/SearchBox/SearchBox.js